import { call, restService } from './apiHelpers';

export const leaderService = {
  ...restService('punteros'),
  createForActor: (payload) => call('post', 'punteros/', payload),
};
